import type { RouteRecordRaw, Router } from 'vue-router'

const PeaceContractRoutes: RouteRecordRaw = {
  path: '/contract/financial/peace',
  name: 'PeaceModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'PeaceMainRoute',
      component: () => import('./views/AccordView.vue'),
      meta: {
        title: 'peace.peaceContract',
      },
    },
    {
      path: 'create',
      name: 'PeaceCreateRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'peace.createPeaceContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:accordId',
      name: 'PeaceEditRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'peace.editPeaceContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:accordId',
      name: 'ViewPeaceRoute',
      component: () => import('./views/SingleAccordView.vue'),
      meta: {
        title: 'peace.ViewPeace',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(PeaceContractRoutes)
}
